import React, { Dispatch, SetStateAction } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useReceberLeadProposta } from "services/api/AppWeb_PropostaVendas/receber-lead-proposta";
import * as Styles from "./styles";
import SelectComponent from "../../../../../../../../selectAutoCompleteG";

interface Props {
  onClose: () => void;
  leadProducts: { label: string; value: string; idLeadCorretor: string };
  setLeadProducts: Dispatch<
    SetStateAction<{ label: string; value: string; idLeadCorretor: string }>
  >;
  setOpenModalEscolherOpcao: (val: boolean) => void;
  dataResumo: any;
  setOpenModalProposta?: any;
  selectedItem?: any;
}

const Footer: React.FC<Props> = (props) => {
  const { idCorretorSistemaOrigem } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data } = useReceberLeadProposta();

  const handleClick = () => {
    if (props.dataResumo?.simuladorAssociativo === false) {
      window.location.pathname = `lead-detail/${props.leadProducts.idLeadCorretor}/${props.leadProducts.value}/repasse-chaves/${props.selectedItem?.idUnidade}`;
      props.onClose();
    }
    if (props.dataResumo?.simuladorAssociativo === true) {
      props.setOpenModalEscolherOpcao(true);
      props.onClose();
    }
  };

  return (
    <>
      <Styles.Container>
        <SelectComponent
          borderRadius="8px"
          disabled={!data}
          data={
            data
              ? data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.idLead,
                  idLeadCorretor: item?.idLeadCorretor,
                }))
              : []
          }
          value={props.leadProducts}
          onChange={(event: {
            label: string;
            value: string;
            idLeadCorretor: string;
          }) => {
            props.setLeadProducts(event || { label: "", value: "" });
          }}
        />
      </Styles.Container>
      <Styles.SecondContainer>
        <Styles.Button onClick={props?.onClose}>
          <Styles.LightTextBlue>Voltar</Styles.LightTextBlue>
        </Styles.Button>
        <Styles.ButtonBlue
          disabled={
            props.leadProducts.value === "" || props.leadProducts.label === ""
          }
          onClick={() => {
            handleClick();
          }}
        >
          <Styles.LightText>Continuar</Styles.LightText>
        </Styles.ButtonBlue>
      </Styles.SecondContainer>
    </>
  );
};

export default Footer;
